<template>
  <div class="out">
    <banner />
    <div class="stickybar">
      <a :style="nowindex===1 ? {'border-bottom': '3px solid #0086f1'} : {'border': 'none'}" @click="jump(1)">产品简介</a>
      <a :style="nowindex===2 ? {'border-bottom': '3px solid #0086f1'} : {'border': 'none'}" @click="jump(2)">功能介绍</a>
      <a :style="nowindex===3 ? {'border-bottom': '3px solid #0086f1'} : {'border': 'none'}" @click="jump(3)">产品优点</a>
      <a :style="nowindex===4 ? {'border-bottom': '3px solid #0086f1'} : {'border': 'none'}" @click="jump(4)">成功案例</a>
    </div>
    <div
      ref="parti"
      class="review"
      style="background-color: rgba(255, 255, 255); margin-left: 0; margin-right: 0"
    >
      <div class="title">
        <div id="partone" class="top-text">
          <h3
            style="font-weight: bolder;color: rgb(37, 108, 255);">阳光村务简介</h3>
          <p class="big_des"><br>阳光村务是睿泽运用“互联网+”技术，打造出的微信公众号监督监管平台，村民通过该软件可以直接进行财务、资产、
          资源等信息查看，可以更好的了解政府政策以及各项开支明细。</p>
        </div>
      </div>
    </div>

    <div id="parttwo" ref="partii" class="function-wrap wow bounceInUp" data-wow-duration="1s" data-wow-delay="0s">
      <div class="function-box">
        <p class="h1">阳光村务功能介绍</p>
        <ul class="function-content">
          <li v-for="(item, index) in functionArr" :key="index">
            <i :class="`function-${index+1}`"/>
            <p class="title1">{{ item.title }}</p>
            <p class="detail">
              {{ item.desc }}<br >
            </p>
          </li>
        </ul>
      </div>
    </div>
    <div id="partthree" ref="partiii" class="gc_ceng gc_ceng_four wow bounceInLeft" data-wow-duration="1s" data-wow-delay="0s">
      <div class="ceng_thin">
        <div class="ceng_title">阳光村务优点</div>
        <div class="ceng_decro"/>
        <div class="ceng_box">
          <div>
            <div>
              <img alt="" src="@/assets/sunshine7.svg" width="150px" lazy="loaded">
            </div>
            <p>公平公正<br>“小微权力”清单、运行流程图和包括村务台账在内的所有村务、居务信息被线上公开并及时更新
            </p>
          </div>
          <div>
            <div>
            <img style="zoom:0.5" alt="" src="@/assets/sunshine8.svg" width="200px" height="200px" margin-left="100px" lazy="loaded"></div>
            <p>简单  高效 <br>村务小单元，诠释大政治，手机上面可一目了然查看村级所有事务，调动了群众监督的积极性
            </p>
          </div>
          <div>
            <div>
              <img alt="" src="@/assets/sunshine9.svg" width="140px" lazy="loaded">
            </div>
            <p>传递为民情怀<br>开设活动专题活动，为村级宣传公益文章，依托“阳光村务”可引进扶贫投资项目，拉动经济发展。</p>
          </div>
          <!-- <div>
                <div>
                    <img alt="" src="../assets/logo.png" width="150px" lazy="loaded">
                </div>
                <p>Lorem, ipsum dolor.<br>Lorem, ipsum dolor.<br>Lorem, ipsum dolor.</p>
            </div> -->
        </div>
      </div>
    </div>
    <div id="partfour">
      <cs-btm :show="false" title="苏州市吴中区农业农村局：“三资系统”阳光村务平台" desc="苏州市吴中区农业农村局联合睿泽构建“阳光村务”监督监管平台，手机一点,村级事务一目了然，各行业各部门对村级实施的项目情况也了如指掌，不仅调动了群众监督的积极性，也为推进全面从严治党向基层延伸提供了有效保障。" />
      <div slot="img" class="customer_iframe">
        <div class="shop-dashboard-homepage">
          <div class="shop-dashboard-homepage__header"/>
          <img src="https://wuzhong-assets.oss-accelerate.aliyuncs.com/assets/zd/01010802/~YLXJBNHDD}})X$FKN2TR[1.png" width="320" height="500" class="shop-dashboard-homepage__iframe">
          <!-- <iframe src="http://www.wzsunshine.cn/sunshine?pid=3&titile=%E9%98%B3%E5%85%89%E6%9D%91%E5%8A%A1" width="320" height="500" class="shop-dashboard-homepage__iframe"/> -->
        </div>
        <div class="shop-dashboard-homepage">
          <div class="shop-dashboard-homepage__header"/>
          <img src="https://wuzhong-assets.oss-accelerate.aliyuncs.com/assets/zd/01010802/[E{X@F`JPKC`$@LTE}_6SEC.png" width="320" height="500" class="shop-dashboard-homepage__iframe">
          <!-- <iframe src="http://www.wzsunshine.cn/notice?deptId=65&infoType=7&type=4&title=%E6%9D%91%E5%8A%A1%E5%85%AC%E5%BC%80" width="325" height="500" class="shop-dashboard-homepage__iframe"/> -->
        </div>
        <div class="shop-dashboard-homepage">
          <div class="shop-dashboard-homepage__header"/>
          <img src="https://wuzhong-assets.oss-accelerate.aliyuncs.com/assets/zd/01010802/0$@DJC1C{427`P@(1Q)4D}K.png" width="320" height="500" class="shop-dashboard-homepage__iframe">
          <!-- <iframe src="http://www.wzsunshine.cn/powerList?deptId=65" width="325" height="500" class="shop-dashboard-homepage__iframe"/> -->
        </div>
      </div>
      <!-- <div>
        <p>客户成功案例</p>
        <div class="customer_success-box"/>
        <h4>苏州市吴中区农业农村局：智慧资产系统化管理</h4>
        <p class="wuzhong_desc">苏州吴中区农业农村局联合睿泽构建“资产管理”数字化运营平台，对镇级，村级资产数据进行统一管控、监管管理、流程管理提升运营效率，释放管理价值。    </p>
      </div> -->
    </div>
    <CircleBtn @back="back" />

  </div>
</template>

<script>
import myCarousel from '../components/carousel'
import CsBtm from './CsBtm.vue'
import Introducecard from './introducecard.vue'
import Banner from '@/views/products/components/Banner'
import CircleBtn from '@/components/CircleBtn.vue'

export default {
  name: 'Sunshine',
  components: { myCarousel, Introducecard, CsBtm, Banner, CircleBtn },
  data() {
    return {
      nowindex: 1,
      functionArr: [
        { title: '信息资讯', desc: '乡镇简介、工作动态、党务公开以及防疫工作推进等' },
        { title: '小微权利', desc: '村级决策、人事管理、救助救济等信息公布' },
        { title: '财务公开', desc: '收支明细、合同金额、各项补贴等费用公布' },
        { title: '党务公开', desc: '党员信息、活动内容公布' },
        { title: '事务公开', desc: '重大项目、低保、社会救助等信息公示' },
        { title: '我村资产', desc: '村集体资产信息公布' }
      ]
    }
  },
  methods: {
    back() {
      this.$router.go(-1)
    },
    jump: function(x) {
      this.nowindex = x
      if (x === 1) {
        x = '#partone'
      }
      if (x === 2) {
        x = '#parttwo'
      }
      if (x === 3) {
        x = '#partthree'
      }
      if (x === 4) {
        x = '#partfour'
      }
      document.querySelector(x).scrollIntoView(true)
    }
  }
}
</script>

<style scoped>
* {
  margin: 0;
}

.title {
  /* width: 1200px; */
  text-align: center;
  margin: 0 auto;
}

.top-text {
  padding: 5.5% 0 4% 0;
}

.stickybar {
  position: sticky;
  top: 0;
  display: flex;
  background-color: white;
  z-index: 99;
  padding: 0% 7% 0% 13%;
}
.stickybar a {
  padding: 2% 4%;
  cursor: pointer;
  text-decoration: none;
  color: black;
}
li {
  list-style-type: none;
}
.function-wrap {
  width: 100%;
  /* height: 890px; */
  position: relative;
  /* background: url(../assets/function_bg.jpg) 50% 50% no-repeat; */
  background-size: cover;
  /* -ms-behavior: url(css/backgroundsize.min.htc);
  behavior: url(css/backgroundsize.min.htc); */
}
.function-box {
  /* width: 1210px; */
  position: relative;
  overflow: hidden;
  margin: 0 auto;
}
.function-box > p.h1 {
  font-size: 32px;
  color: #333;
  text-align: center;
  line-height: 1;
  padding: 70px 0 ;
}
.function-content {
  width: 100%;
  position: relative;
  display: flex !important;
  flex-direction: row !important;
  flex-wrap: wrap !important;
  justify-content: space-between !important;
}
.function-content li {
  position: relative;
  width: 33%;
  /* width: 350px;
  height: 250px;
  float: left;
  margin-left: 40px; */
  background: #fff;
  border-radius: 5px;
  margin-bottom: 70px;

}
.function-content li:first-child,
.function-content li:first-child + li + li + li {
  margin-left: 0px;
}
.function-content li:first-child + li + li + li + li + li + li {
  margin-left: 0px;
}
.function-content li p.title1 {
  text-align: center;
  line-height: 1;
  font-size: 20px;
  color: #292929;
  margin: 20px 0;
  /* padding: 100px 0 30px; */
}
.function-content li p.detail {
  text-align: center;
  line-height: 180%;
  font-size: 14px;
  color: #7f7f7f;
}
.function-content li i {
  display: block;
  width: 193px;
  height: 176px;
  margin: 0 auto;
  zoom: 0.8;
  /* position: absolute;
  left: 50%;
  margin-left: -50px;
  top: -50px; */
  border: solid 1px #BBBBBB;
  border-radius: 100%;
}
.function-content li i.function-1 {
  color: rgba(225, 93, 93, 100);
  background: url('~@/assets/sunshine1.svg')  no-repeat 50% 50%;
}
.function-content li i.function-2 {
  background: url('~@/assets/sunshine2.svg') no-repeat 50% 50%;
}
.function-content li i.function-3 {
  background: url('~@/assets/sunshine3.svg') no-repeat 50% 50%;
}
.function-content li i.function-4 {
  background: url('~@/assets/sunshine4.svg') no-repeat 50% 50%;
}
.function-content li i.function-5 {
  background: url('~@/assets/sunshine5.svg') no-repeat 50% 50%;
}
.function-content li i.function-6 {
  background: url('~@/assets/sunshine6.svg') no-repeat 50% 50%;
}

.gc_ceng.gc_ceng_four {
    padding: 70px 0 70px 0;
    background: #fff;
    background: url(~@/assets/products-bg.714f810.png)
}

.gc_ceng .ceng_thin {
    max-width: 1200px;
    width: 100%;
    margin: 0 auto;
    text-align: left;
}

.gc_ceng .ceng_thin .ceng_title {
    font-size: 32px;
    font-family: PingFangSC-Medium,PingFang SC;
    font-weight: 500;
    color: #333;
    line-height: 40px;
    margin: 0 0 20px;
    text-align: center;
}

.customer_success {
  width: 100%;
  margin: 0 auto;
  padding-top: 85px;
  padding-bottom: 90px;
}
.customer_iframe {
  display: flex;
  margin-top: -20px;
  padding-bottom: 20px;
  justify-content: space-around;
}
p:nth-child(1) {
    margin: auto;
    width: auto;
    height: auto;
    font-size: 32px;
    font-family: PingFang SC;
    font-weight: 500;
    color: rgba(6,24,40,1);
}
h4 {
  margin: 20px 0 10px
}
.wuzhong_desc {
    margin: auto;
    margin-top: 20px;
    width: 1000px;
    height: auto;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 300;
    color: rgba(13,10,38,1);
    line-height: 24px;
    text-align: center;
}
.customer_success-box {
  max-width: 1200px;
  margin: 50px auto 0 auto;

}
.customer_success-box  img {
  width: 90%;
  margin: 0 auto;
  border: solid
}
.gc_ceng .ceng_thin .ceng_decro {
    font-size: 16px;
    font-family: PingFangSC-Regular,PingFang SC;
    font-weight: 400;
    color: #666;
    line-height: 15px;
    margin: 0 0 70px;
    text-align: center;
}

.gc_ceng.gc_ceng_four .ceng_box {
    display: flex;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
}

.gc_ceng.gc_ceng_four .ceng_box>div {
    -webkit-box-flex: 0;
    flex: 0 0 280px;
    margin: 0 0 40px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
}

.gc_ceng.gc_ceng_four .ceng_box>div>div {
    width: 180px;
    height: 180px;
    margin: 0 auto;
    background: #fff;
    -webkit-box-shadow: 0 8px 48px 0 rgb(223 226 236 / 60%);
    box-shadow: 0 8px 48px 0 rgb(223 226 236 / 60%);
    border-radius: 50%;
    margin-bottom: 20px;
}

.gc_ceng.gc_ceng_four .ceng_box>div>p {
    text-align: center;
    font-size: 15px;
    font-family: PingFangSC-Regular,PingFang SC;
    font-weight: 400;
    color: #333;
    line-height: 34px;
}
.gc_ceng.gc_ceng_four .ceng_box>div>div>img {
    /* max-width: 100%; */
    max-height: 100%;
    position: relative;
    left: 50%;
    top: 50%;
    -webkit-transform: translate(-50%,-50%);
    transform: translate(-50%,-50%);
    zoom: 0.7;
}

#partfour {
  background: rgba(234,239,243,1);
}

.practice h1{
  padding: 50px 0 50px 0;
}

.practice img {
  padding: 50px 0 50px 0;
}

#solutiontext {
  color:whitesmoke;
  padding-bottom: 30px;
}

.solutionList {
  color: whitesmoke;
  display: flex;
  justify-content: space-around;
  background-color: #000413;
}

.solutionContent {
  display: flex;
  padding-top: 30px;
}

.solutionList h4 {
  margin: 0;
}

.leftList {
  width: 400px;
}

.listItem {
  padding: 20px 100px 20px 100px;
  background-color: #000413;
}

.leftItem p{
  color: whitesmoke;
  text-align: left;
  padding: 2%;
}

.leftItem {
  display: flex;
  margin:5px;
  padding:3px;
  background: linear-gradient(to right,rgba(64, 224, 208, 1), rgba(64, 224, 208, 0));
}

.shop-dashboard-homepage {
  width: 325px;
  margin-top: 20px;
  /* margin-left: 50px; */
}
.shop-dashboard-homepage__header {
  height: 65px;
  /* width: 325px; */
  background-image: url(~@/assets/mobile_bg.png);
  background-repeat: no-repeat;
  background-size: 100%;
  border: 1px solid #e5e5e5;
  border-bottom: 0;
}
.shop-dashboard-homepage__title {
  display: inline-block;
  padding: 23px 40px 0 60px;
  height: 55px;
  line-height: 31px;
  width: 100%;
  box-sizing: border-box;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  font-weight: 700;
  font-size: 16px;
  text-align: center;
  vertical-align: middle;
  color: #111;
}
.shop-dashboard-homepage__iframe {
  border: 1px solid #e5e5e5;
  border-top: 0;
}

.preview_btn {
  position: absolute;
  right: 30px;
  top: 500px;
}

/* .rightContent {
  background: url(../assets/solution3-1.97f0170.png);
  width:780px;
  height: 600px;
  margin: auto;
}

.rightContent p {
  color:whitesmoke;
  text-align:left;
} */

#review2 {
  background: url(../assets/solution-bg.2000a70.png) no-repeat 50%;
}

#myh2 {
  background: url(../assets/sqc.png) no-repeat 50% 50%
}

.jn_lisyc li {
    width: 48%;
    float: left;
    margin-right: 4%;
    margin-bottom: 16px;
    height: 114px;
}

.jn_lisyc li:nth-of-type(2n) {
    margin-right: 0;
}

.jn_lisyc {
    overflow: hidden;
}

.fl {
    float: left;
}

.content {
    width: 400px;
    margin-left: 48px;
}

dd {
    margin-bottom: .5rem;
    margin-left: 0;
}

.content dd {
    font-size: 22px;
    color: #333333;
}

.rikc {
    margin: 50px auto;
}
</style>>



// WEBPACK FOOTER //
// src/components/sunshine.vue